<template>
  <instructions-component
    class="pointer-events-auto midder"
    :header="$t('instructions')"
    :button-text="$t('continue')"
    :cards="getInstructions"
    show-button
    @button-click="closeInstructions"
  />
</template>

<script lang="ts">
import { Instructions } from '@powerplay/core-minigames-ui'
import { defineComponent } from 'vue'
import {
  CorePhases,
  corePhasesManager,
  modes,
  tutorialManager
} from '@powerplay/core-minigames'
import { pathAssets } from '@/globals/globalvariables'
import { blurState } from '@/stores'

export default defineComponent({
  name: 'InstructionComponent',
  components: {
    InstructionsComponent: Instructions
  },
  props: {
    isMobile: {
      type: Boolean,
      required: true
    }
  },
  emits: ['close-instructions'],
  computed: {
    getInstructions(): {imgSrc: string, header: string, text: string[]}[] {

      blurState().isActive = true

      if (modes.isTrainingMode()) {

        return [
          {
            imgSrc: `${pathAssets}/ui/instructions/training-1.png`,
            header: this.$t('instructionsDisciplineTraining4Cell1Title'),
            text: [this.$t('instructionsDisciplineTraining4Cell1Text1')]
          },
          {
            imgSrc: `${pathAssets}/ui/instructions/training-2.png`,
            header: this.$t('instructionsDisciplineTraining4Cell2Title'),
            text: [this.$t('instructionsDisciplineTraining4Cell2Text1')]
          },
          {
            imgSrc: `${pathAssets}/ui/instructions/training-3.png`,
            header: this.$t('instructionsDisciplineTraining4Cell3Title'),
            text: [this.$t('instructionsDisciplineTraining4Cell3Text1')]
          }
        ]

      }

      return [
        {
          imgSrc: `${pathAssets}/ui/instructions/instructions-1.png`,
          header: this.$t('instructionsDiscipline4Cell1Title'),
          text: [this.$t('instructionsDiscipline4Cell1Text1')]
        },
        {
          imgSrc: `${pathAssets}/ui/instructions/instructions-2.png`,
          header: this.$t('instructionsDiscipline4Cell2Title'),
          text: [this.$t('instructionsDiscipline4Cell2Text1')]
        },
        {
          imgSrc: `${pathAssets}/ui/instructions/instructions-3.png`,
          header: this.$t('instructionsDiscipline4Cell3Title'),
          text: [
            this.$t('instructionsDiscipline4Cell3Text1'),
            this.$t('instructionsDiscipline4Cell3Text2')
          ]
        }
      ]

    }
  },
  methods: {
    closeInstructions(): void {

      // pokial mame prvotne instrukcie, tak ich zavrieme
      if (corePhasesManager.isActivePhaseByType(CorePhases.instructions)) {

        corePhasesManager.getActualPhase()?.finishPhase()

      }
      this.$emit('close-instructions')
      tutorialManager.blockInputsManually()

    }
  }

})
</script>

<style lang="less" scoped>
</style>
